<template>
  <gj-modal
    :visible.sync="modalVisible"
    size="middle-height-auto"
  >
    <template #header>排除促销编码</template>
    <template #content>
      <el-row style="height: 400px">
        <el-col :span="11" style="border: 1px solid #e5e5e5; height: 100%">
          <div class="filter">
            <app-filter-group :reset="false" :query="false">
              <gj-select
                type="multi-check"
                v-model="country"
                placeholder="全部国家"
                width="160px"
                :options="[
                    {id: 'US', text: 'US'},
                    {id: 'CA', text: 'CA'},
                    {id: 'DE', text: 'DE'},
                ]"
                @input="filter"
              ></gj-select>
              <gj-search-input
                v-model="promotionCode"
                width="160px"
                placeholder="请输入促销编码"
                @input="filter"
              ></gj-search-input>
            </app-filter-group>
          </div>
          <div class="promotion-code">
            <div class="checkbox-mg">
              <el-checkbox :indeterminate="checkbox.indeterminate" v-model="checkbox.checkAll" @change="handleChangeAll">全选</el-checkbox>
            </div>
            <div>
              <el-checkbox-group v-model="checkbox.checkboxList" @change="handleChangeChild">
                <div v-for="(item, index) in leftList" :key="index" :class="[index !== leftList.length ? 'checkbox-mg' : '']">
                  <el-checkbox :key="item.code" :label="item.code">{{item.code}}</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>

          </div>
        </el-col>
        <el-col :span="2" style="height: 100%">
          <div class="transfer">
            <i @click="transfer" class="el-icon-d-arrow-right" style="font-size: 20px; cursor: pointer"></i>
          </div>
        </el-col>
        <el-col :span="11" style="border: 1px solid #e5e5e5; height: 100%; overflow: auto">
          <div>
            <div class="right-title">
              <el-row style="padding-top: 12px; padding-left: 12px">
                <el-col :span="12">
                  已选促销编码 {{rightList.length}}
                </el-col>
                <el-col :span="12" style="text-align: right; padding-right: 12px">
                  <gj-button style="padding: 0" type="text" @click="removeAll">全部移除</gj-button>
                </el-col>
              </el-row>
            </div>
            <div class="promotion-code">
              <el-row v-for="(item, index) in rightList" :key="index" :class="[index !== rightList.length ? 'right-content' : '']">
                <el-col :span="20">
                  {{item.code}}
                </el-col>
                <el-col :span="4">
                  <gj-button style="padding: 0;" type="text" @click="remove(index)">移除</gj-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button type="primary" @click="$emit('confirm')">确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn} from "../../../../../minxins";
    import {isNotBlank} from "../../../../../utils/common";

    export default {
        name: "promotion-analysis-filter",
        mixins: [modalMixIn],
        props: {
            filterList: {
                type: Array,
                default: () => ([])
            }
        },
        created() {
            this.rightList = this.filterList;
            this.filter();
        },
        data() {
            return {
                sourceList: [
                    {country: 'US', code: '[88W-111319-R6F2BPKH-FB50%]'},
                    {country: 'US', code: '[US Core Free Shipping Promotion A3JU1FCINF5SD0]'},
                    {country: 'CA', code: '[MPC-S 购买折扣 2020/11/17 4-37-10-972]'},
                ],
                leftList: [],
                rightList: [],
                country: null,
                promotionCode: null,
                checkbox: {
                    checkboxList: [],
                    indeterminate: false,
                    checkAll: false,
                }
            }
        },
        methods: {
            filter() {
              let list = [];
              if (this.country && this.country.length> 0) {
                  this.country.forEach(val => {
                      list.push(...this.sourceList.filter(v => v.country.includes(val)));
                  });
              } else {
                  list = this.sourceList;
              }
              if (isNotBlank(this.promotionCode)) {
                  list = list.filter(v => v.code.toLowerCase().includes(this.promotionCode));
              }
              if (this.rightList && this.rightList.length > 0) {
                  const rightCodeList = this.rightList.map(v => v.code);
                  list = list.filter(v => rightCodeList.indexOf(v.code) === -1);
              }
              this.leftList = [].concat(list);
              this.handleChangeChild();
            },
            handleChangeAll(event) {
                this.checkbox.indeterminate = false;
                this.checkbox.checkAll = event;
                if (event) {
                    this.checkbox.checkboxList = [].concat(this.leftList.map(v => v.code));
                } else {
                    this.checkbox.checkboxList = []
                }
            },
            handleChangeChild() {
                this.checkbox.checkAll = this.leftList.every(v => this.checkbox.checkboxList.indexOf(v.code) !== -1);
                this.checkbox.indeterminate = !this.checkbox.checkAll && this.leftList.some(v => this.checkbox.checkboxList.indexOf(v.code) !== -1);
            },
            transfer() {
                this.checkbox.checkAll = false;
                this.checkbox.indeterminate = false;
                if (this.checkbox.checkboxList && this.checkbox.checkboxList.length > 0) {
                    this.sourceList.filter(v => this.checkbox.checkboxList.indexOf(v.code) !== -1);
                    this.rightList = this.rightList.concat(this.sourceList.filter(v => this.checkbox.checkboxList.indexOf(v.code) !== -1));
                    this.checkbox.checkboxList = [];
                }
                this.filter();
            },
            remove(index) {
                this.rightList.splice(index, 1);
                this.filter();
            },
            removeAll() {
                this.rightList = [];
                this.filter();
            }
        }
    }
</script>

<style scoped>
  .filter {
    padding-top: 8px;
    padding-left: 13px;
    border-bottom: 1px solid #e5e5e5;
    height: 40px;
  }
  .promotion-code {
    padding: 10px;
    height: 330px;
    overflow: auto;
  }
  .checkbox-mg {
    margin-bottom: 6px;
  }
  .promotion-code /deep/ .el-checkbox__label {
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 12px;
  }
  .transfer {
    height: 100%;
    text-align: center;
    align-items: center;
    display: grid;
  }
  .right-title {
    border-bottom: 1px solid #e5e5e5;
    height: 40px;
    font-size: 12px;
    color: #666;
  }
  .right-content {
    font-size: 12px;
    margin-bottom: 6px;
  }
</style>
